import moment from "moment";

export const filters = [
    {
        name: "truncate",
        execute: (value, position) => {
            let text = value;
            if (value && position < value.length) {
                text = value.substring(0, position) + "...";
            }
            return text;
        }
    },
    {
        name: "capitalize",
        execute: value => {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    {
        name: "uppercase",
        execute: value => {
            return value.toUpperCase();
        }
    },
    {
        name:'fixDecimal',
        execute: value => {
            if( typeof value == "number" ) {
                let numberAsString = value.toString()
                if( numberAsString.indexOf('.') != -1 ) {
                    let dotIndex = numberAsString.indexOf('.');
                    let roundedNumber = numberAsString.substring(0, dotIndex+2)
                    return roundedNumber
                }
                return value
            } else {
                if( value.indexOf('.') != -1 ) {
                    let dotIndex = value.indexOf('.');
                    let roundedNumber = value.substring(0, dotIndex+2)
                    return roundedNumber
                }
                return value
            }
        }
    },
    {
        name: "currency",
        execute: value => {
            if( value || value != null ) {
                if( typeof value == "number" ) {
                    let numberAsString = value.toString()
                    if( numberAsString.indexOf('.') != -1 ) {
                        let dotIndex = numberAsString.indexOf('.');
                        let roundedNumber = numberAsString.substring(0, dotIndex+3)
                        return `R$${roundedNumber}`
                    }
                    return `R$${numberAsString}`
                } else {
                    if( value.indexOf('.') != -1 ) {
                        let dotIndex = value.indexOf('.');
                        let roundedNumber = value.substring(0, dotIndex+2)
                        return `R$${roundedNumber}`
                    } else if (value == 'Personalizado') {
                        return `${value}`
                    }
                    return `R$${value}`
                }
            } else return `R$0`
        }
    },
    {
        name: 'fomatDate',
        execute: value => {
            if( value ){
                return moment(value).format("DD/MM/YYYY")
            } else return ``
        }
    },
    {
        name: 'formatTelephone',
        execute: value => {
            if( value ) {
                if( value.length == 13 ) { //Número fixo
                    return `(${value.substring(3,5)}) ${value.substring(5,9)}-${value.substring(9)}`
                } else { //Celular
                    return `(${value.substring(3,5)}) ${value.substring(5,6)} ${value.substring(6,10)}-${value.substring(10)}`
                }
            }else return ``
        }
    },
    {
        name: 'formatSeconds',
        execute: value => {
            if(value){
                return `${value.substring(0,5)}`
            }else return ``
        }
    }
];